import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Alert } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:도매검색 입력
 * 세부설명:
*/

export class WholeInputSearch extends Component {
    static displayName = WholeInputSearch.name;

    constructor(props) {
        super(props);
        this.state = {
            BldList: [],
            Bld_Code: "",
            FlrList: [],
            Flr_Code: "",
            Whole_No_List: [],
            Whole_No_Value:"",
            Whole_Name_List: [],
            Whole_Name_Value: "",   //Whole_Name_Value, Whole_Name_inputValue는 항상 쌍으로 셋팅
            Whole_Name_inputValue:"",
            Retail_Memo: "",
            ReturnUseYn: "N",
            isReturn: "N",
            ButtonList:[],
            isOk: false
        };
        this.ref_WholeInputSearch = React.createRef();
        this.handleBlid_Click = this.handleBlid_Click.bind(this);
        this.handleFlr_Change = this.handleFlr_Change.bind(this);
        this.handleWholeSelected_Change = this.handleWholeSelected_Change.bind(this);
        this.handleWholeInput_Change = this.handleWholeInput_Change.bind(this);
        this.handleCheck_Click = this.handleCheck_Click.bind(this);
        this.handleMemo_Change = this.handleMemo_Change.bind(this);
        this.handleConfirm_Click = this.handleConfirm_Click.bind(this);

        this.Whole_No_Code = "";
        this.Whole_Code = "";
        this.TempFlrList = [];
        //마지막 값을 반환할때 사용
        this.TempWhole_Name_List = [];
    }
    
    async componentDidMount() {
        //부모창 로드할때 조회
        try {
            let Data = await Big3Common.Get("api/Common/Common/BldMgt");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataSet = JSON.parse(Data.multiDataTable);
                //빌딩
                const BldList = DataSet.BldList;
                this.TempFlrList = DataSet.FlrList;
                this.setState({
                    BldList: BldList
                });
            }
            //사입버튼 리스트
            let ButtonData = await Big3Common.Get("api/MyPage/ExcelOrder/GetButton_List");
            if (ButtonData.codeName === Big3Common.ResultCode.Success) {
                const DataSet = JSON.parse(ButtonData.multiDataTable);
                const ReturnUseYn = DataSet.ReturnUseYn;
                const ButtonList = DataSet.ButtonList;
                this.setState({
                    ReturnUseYn: ReturnUseYn,
                    ButtonList: ButtonList
                });
            }
        }
        catch (e) {
            console.log("DefaultData :", e);
        }
    }

    //초기화
    initWholeSearch = () => {
        
        const ButtonList = this.state.ButtonList.map(button => ({
            ...button,
            selected: 'N'
        }));
        this.setState({
            Bld_Code: "",
            FlrList: [],
            Flr_Code: "",
            Whole_No_List: [],
            Whole_No_Value: "",
            Whole_Name_List: [],
            Whole_Name_Value: "",
            Whole_Name_inputValue: "",
            ButtonList: ButtonList,
            Retail_Memo: "",
        });
        this.Whole_No_Code = "";
        this.Whole_Code = "";
        this.TempWhole_Name_List = [];
        return false;
    }    
    //상가 호수 조회
    async CallWhole_No_List(Bld_Code, Flr_Code) {
        let Whole_No_List = [];
        try {
            let Data = await Big3Common.Post('api/Common/Common/GetWhole_No_List',
                {
                    bld_code: Bld_Code,
                    flr_code: Flr_Code
                });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                DataList.map(list => Whole_No_List.push({ "label": list.whole_no_name, "whole_no_code": list.whole_no_code }));
                return Whole_No_List;
            }
        }
        catch (e) {
            console.log("CallWhole_No_List", e);
        }
       
    }
    //상호명 검색
    async CallWhole_Name_List(Bld_Code, Flr_Code, Whole_No_Code, Whole_Name) {
        
        let Whole_Name_List = [];
        try {
            let Data = await Big3Common.Post('api/MyPage/ExcelOrder/GetWhole_Name_List',
                {
                    bld_code: Bld_Code,
                    flr_code: Flr_Code,
                    whole_no_code: Whole_No_Code,
                    whole_name: Whole_Name
                });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                this.TempWhole_Name_List = DataList;
                DataList.map(list => Whole_Name_List.push({ "label": `(${list.bld_name}) ${list.flr_name}ㆍ${list.whole_no_name}ㆍ${list.whole_name}`, "whole_code": list.whole_code }));
                return Whole_Name_List;
            }
        }
        catch (e) {
            console.log("CallWhole_Name_List", e);
        }
       
    }

    //빌딩 클릭
    handleBlid_Click = async (event, list) => {
        if (this.state.Bld_Code === list.bld_code) {
            //선택한걸 다시 선택
            this.initWholeSearch();
            return false;
        }
        const Bld_Code = list.bld_code;
        const FlrList = this.TempFlrList.filter(list => list.bld_code === Bld_Code);
        const Flr_Code = FlrList.length === 0 ? "" : FlrList[0].flr_code;
        const Whole_No_List = await this.CallWhole_No_List(Bld_Code, Flr_Code);
        const Whole_Name_List = await this.CallWhole_Name_List(Bld_Code, Flr_Code,"", "");
        this.setState({
            Bld_Code: Bld_Code,
            FlrList: FlrList,
            Flr_Code: Flr_Code,
            Whole_No_List: Whole_No_List,
            Whole_No_Value: "",
            Whole_Name_List: Whole_Name_List,
            Whole_Name_Value: "",
            Whole_Name_inputValue: ""
        });
        this.Whole_No_Code = "";
        this.Whole_Code = "";
        event.preventDefault();
    }
    //층 클릭
    handleFlr_Change = async (event) => {
        const Flr_Code = event.target.value;
        if (Flr_Code !== undefined && Flr_Code !== "") {
            const Whole_No_List = await this.CallWhole_No_List(this.state.Bld_Code, Flr_Code);
            const Whole_Name_List = await this.CallWhole_Name_List(this.state.Bld_Code, Flr_Code, "", "");
            this.setState({
                Flr_Code: Flr_Code,
                Whole_No_List: Whole_No_List,
                Whole_No_Value: "",
                Whole_Name_List: Whole_Name_List,
                Whole_Name_Value: "",
                Whole_Name_inputValue: ""
            });
            this.Whole_No_Code = "";
            this.Whole_Code = "";
        }
    }
    //호수 또는 상가명을 선택 했을때
    handleWholeSelected_Change = async (event, Data) => {
        console.log("==>",event);
        let targetID = event.target.id;
        if (targetID === "") {
            //x를 클릭하면 id 값을 구할 수 없음
            targetID = event.target.parentNode?.parentNode?.parentNode?.childNodes[0]?.id;
        }
        if (targetID.includes("whole_no_name")) {
            if (Data !== null) {
                //리스트 박스에 바인딩할 블록 데이터
                const Whole_Name_List = await this.CallWhole_Name_List(this.state.Bld_Code, this.state.Flr_Code, Data.whole_no_code, "");
                this.setState({
                    Whole_No_Value: Data,
                    Whole_Name_List: Whole_Name_List,
                    Whole_Name_Value: Whole_Name_List.length === 1 ? Whole_Name_List[0] : "",
                    Whole_Name_inputValue: Whole_Name_List.length === 1 ? Whole_Name_List[0].label : "",
                });
                //자신의 Whole_No_Code를 전역변수에 할당
                this.Whole_No_Code = Data.whole_no_code;
                //1개만 존재할 경우 기본값 설정
                this.Whole_Code = Whole_Name_List.length === 1 ? Whole_Name_List[0].whole_code : "";
            }
            else {
                this.Whole_Name_Clear();
            }
        }
        else if (targetID.includes("whole_name")) {
            if (Data !== null) {
                //리스트 박스에 바인딩할 블록 데이터
                this.setState({
                    Whole_Name_Value: Data,
                    Whole_Name_inputValue: Data.label
                });
                //자신의 Whole_Code를 전역변수에 할당
                this.Whole_Code = Data.whole_code;
            }
            else {
                this.setState({
                    Whole_Name_Value: "",
                    Whole_Name_inputValue: ""
                });
                this.Whole_Code = "";
            }
        }
        return false;
    }
    //확인버튼을 클릭하거나, 호수의 (x) 버튼을 클릭했을때 호수와 상가명 초기화
    Whole_Name_Clear = async () => {
        const Whole_Name_List = await this.CallWhole_Name_List(this.state.Bld_Code, this.state.Flr_Code, "", "");
        this.setState({
            Whole_No_Value: "",
            Whole_Name_List: Whole_Name_List,
            Whole_Name_Value: "",
            Whole_Name_inputValue: ""
        });
        this.Whole_No_Code = "";
        this.Whole_Code = "";
    }
    //매장 이름 클릭
    handleWholeInput_Change = async (event, TextVale) => {
        if (this.state.Bld_Code === "") {
            if (event.type ==="change" && TextVale.trim() !=="" && TextVale.length > 1) {
               const Whole_Name_List = await this.CallWhole_Name_List(this.state.Bld_Code, this.state.Flr_Code, this.Whole_No_Code, TextVale);
                this.setState({
                    Whole_Name_inputValue: TextVale,
                    Whole_Name_List: Whole_Name_List
                });
            }
        }
        this.setState({
            Whole_Name_inputValue: TextVale,
        });
        return false;
    }
    //주문하기 체크박스 선택
    handleCheck_Click = (event, list) => {

        const selected = list.selected === "N" ? "Y" : "N";
        list.selected = selected;
        let isReturn = this.state.isReturn;
        if (list.memo_dtl_code === "OD" && selected === "Y") {
            isReturn = "Y";
        }
        const MessageList = this.state.ButtonList.filter(list => list.selected === "Y");
        const Retail_Memo = MessageList.map(list => { return list.content }).join(',');

        this.setState({ Retail_Memo: Retail_Memo, isReturn: isReturn });
        return false;
    }
    //내용입력
    handleMemo_Change(event) {
        const Value = event.target.value;
        this.setState({ Retail_Memo: Value });
    }
    //도매선택 최종확인 및 적용
    handleConfirm_Click = (event) => {
        if (this.props.CallBack !== undefined) {
            if (this.Whole_Code === "") {
                Big3Common.ModalAlert(bootstrap, 'AlertWholeSearch');
                return false;
            }
            let WholeList = this.TempWhole_Name_List.filter(list => list.whole_code === this.Whole_Code);
            WholeList[0].user_phone = WholeList[0].whole_phone;
            WholeList[0].return_yn = this.state.isReturn
            this.props.CallBack(WholeList, this.state.Retail_Memo);
            this.Whole_Name_Clear();
            const ButtonList = this.state.ButtonList.map(button => ({
                ...button,
                selected: 'N'
            }));
            this.setState({
                ButtonList: ButtonList,
                Retail_Memo: ""
            });

        }
        event.preventDefault();
    }
    //층 콤보 리스트 
    Flrrender() {
        const FlrList = this.state.FlrList;
        return (
            <select onChange={(e) => {this.handleFlr_Change(e) } }>
                {FlrList.map(list =>
                    <option key={`${list.bld_code}_${list.flr_code}`} value={list.flr_code}>{list.flr_name}</option>
                )}
            </select>
        )
    }
    //빌딩리스트
    Bldrender() {
        const BldList = this.state.BldList;
        return (
            <ul className="db_list_box">
                {
                    BldList.map(list =>
                        <li
                            key={list.bld_code}
                            className={list.bld_code === this.state.Bld_Code ? "c_o_b" : ""}
                            onClick={(e) => { this.handleBlid_Click(e,list) }}
                        >{list.bld_name}
                        </li>
                    )
                }
            </ul>
        )
    }
    Buttonrender = () => {
        const ReturnUseYn = this.state.ReturnUseYn;
        const ButtonList = this.state.ButtonList;
        if (ReturnUseYn === undefined || ReturnUseYn === "" || ReturnUseYn === "N") {
            return ("");
        }
        if (ButtonList.length === 0) {
            return ("");
        }
        return (
            <ul className="db_list_box">
                {ButtonList.map(list =>
                    <li key={list.memo_dtl_code} >
                        <input type="checkbox" id={list.memo_dtl_code}
                            checked={list.selected === "Y" ? true : false}
                            onChange={() => { return false; }}
                            className="btn type02"
                        />
                        <label htmlFor={list.memo_dtl_code} onClick={(e) => { this.handleCheck_Click(e, list) }}>{list.content}</label>
                    </li>
                )}
            </ul>
        )
    }

    render() {
        const Bldrender = this.Bldrender();
        const Flrrender = this.Flrrender();
        const Buttonrender = this.Buttonrender();
        return (
            <div ref={this.ref_WholeInputSearch} className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content excel_data_modal">
                        <div className="modal-header EmpDtl_modal_header">
                            <div className="modal-title">주문입력</div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="find_b_box">
                            <div className="title_v2">동대문상가명</div>
                            <div className="c_b_box">
                                {Bldrender }
                                <div className="i_box_out">
                                    <div className="i_b_box">
                                        <label>동대문상가층</label>
                                        {Flrrender }
                                    </div>
                                    <div className="i_b_box">
                                        <label>동대문상가호수</label>
                                        <div>
                                            <Autocomplete
                                                disablePortal
                                                id="whole_no_name"
                                                value={this.state.Whole_No_Value}
                                                onChange={(event, newValue) => { this.handleWholeSelected_Change(event, newValue) }}
                                                options={this.state.Whole_No_List}
                                                sx={{ width: 300 }}
                                                renderInput={(params) => <TextField
                                                    {...params}
                                                />}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="i_b2_box">
                                    <label>동대문상가상호명</label>
                                    <div>
                                        <Autocomplete
                                            disablePortal
                                            id="whole_name"
                                            value={this.state.Whole_Name_Value }
                                            onChange={(event, newValue) => { this.handleWholeSelected_Change(event, newValue) }}
                                            inputValue={this.state.Whole_Name_inputValue}
                                            onInputChange={(event, newValue) => { this.handleWholeInput_Change(event, newValue) }}
                                            options={this.state.Whole_Name_List}
                                            sx={{ width: 300 }}
                                            renderInput={(params) => <TextField
                                                {...params}
                                            />}
                                        />
                                    </div>
                                </div>
                                {Buttonrender}
                            </div>
                        </div>
                        <div className="order_data">
                            <div className="title_v2">주문내용 입력</div>
                            <input type="text"
                                value={this.state.Retail_Memo}
                                onChange={this.handleMemo_Change}
                                placeholder="주문내용을 입력해주세요"
                            />
                        </div>
                        <div className="modal-footer notice_modal_footer">
                            <button type="button"
                                className="m_btn"
                                onClick={(e) => { this.handleConfirm_Click(e) } }
                            >확인</button>
                        </div>
                    </div>
                </div>
                <Alert
                    id="AlertWholeSearch"
                    title="등록안내"
                    content="도매상가를 선택하여 주세요."
                />
            </div>
        );
    }
}
